import Vue from 'vue'

// state
let state = {
    hints: [],// 离线下载 列表
    hintStatus: false, // 提示框状态
    pollstatus: false, // 轮询状态
    start: false
}

// getters
const getters = {
    // 获取显示在提示框的数据
    showList: state => {
        const filterList = Array.isArray(state.hints) && state.hints.filter(item => item.isTip === 0) || []
        filterList.forEach(element => {
            element.isDown = element.status == 3
            element.progressStatus = element.status == 0 ? 'info' : element.status == 1 || element.status == 2 ? 'text' : element.status == 3 ? 'success' : 'exception'
        })
        return filterList
    },
    underwayLength: state => { // 正在下载的数量
        const filterList = Array.isArray(state.hints) && state.hints.filter(item => item.status === 1 || item.status === 2) || []
        return filterList.length
    },
    hintsLength: (state, getters) => {
        return getters.showList.length
    },
    // 获取当前提示框的状态
    hintStatus: state => state.hintStatus,
    // 判断当前所有数据是否都成功或失败
    isAll: state =>{
        return Array.isArray(state.hints) && state.hints.every(item=>{
            return  item.status ==3 || item.status ==4
        })
    }
}

// actions
const actions = {
    // 更新 下载提示得信息
    update({ commit, state,getters }) {
        // 获取axios 用于请求服务器数据
        const axios = Vue.prototype.$axios
        return new Promise((resolve, reject) => {
            let time = 1000
            state.start || (commit('START'), time = 300)
            setTimeout(() => {
                axios.get('/popadmin/admin/down/msg/tip').then((res) => {
                    commit('UPDATE', res.data.data)
                    // 如果所有数据是否都成功或失败，停止轮询
                    getters.isAll && commit('POLLEND')
                    resolve()
                }).catch((err) => {
                    commit('POLLEND')
                    reject(err)
                })
            }, time)

        })

    },
    // 轮询请求
    async pollstart({ dispatch, commit, state, getters }) {
        commit('POLLSTART')
        while (state.pollstatus) {
            await dispatch('update')
            getters.hintsLength === 0 && commit('POLLEND')

        }
    }
}
// mutations
const mutations = {
    // 更新hints数据
    UPDATE(state, data) {
        state.hints = data
    },
    // 显示 提示框
    SHOW(state) {
        state.hintStatus || (state.hintStatus = true)
    },
    // 隐藏 提示框
    HIDE(state) {
        state.hintStatus && (state.hintStatus = false)
    },
    // 设置可以轮询 
    POLLSTART(state) {
        state.pollstatus || (state.pollstatus = true)
    },
    // 停止轮询
    POLLEND(state) {
        state.pollstatus && (state.pollstatus = false)
        state.start && (state.start = false)
    },
    START(state) {
        state.start || (state.start = true)
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}